import React from "react";

function Dollar({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.50016 14.6654C12.1821 14.6654 15.1668 11.6806 15.1668 7.9987C15.1668 4.3168 12.1821 1.33203 8.50016 1.33203C4.81826 1.33203 1.8335 4.3168 1.8335 7.9987C1.8335 11.6806 4.81826 14.6654 8.50016 14.6654Z"
        stroke="currentColor"
      />
      <path
        d="M8.5 4V12M10.5 6.33333C10.5 5.41333 9.60467 4.66667 8.5 4.66667C7.39533 4.66667 6.5 5.41333 6.5 6.33333C6.5 7.25333 7.39533 8 8.5 8C9.60467 8 10.5 8.74667 10.5 9.66667C10.5 10.5867 9.60467 11.3333 8.5 11.3333C7.39533 11.3333 6.5 10.5867 6.5 9.66667"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Dollar;
